import { toast } from "sonner";
import { SupportingDocumentTypesAdmin } from "@lumanity/ui/projects";

const SupportingDocumentTypes = () => <SupportingDocumentTypesAdmin onError={(e) => toast.error(e.message)} />;

export default SupportingDocumentTypes;
